module.exports = __webpack_public_path__ + "static/media/68.d685e1aa.jpg";